/** Round to 2 decimal places (currency). */
export function roundOrderMoney(value: number): number {
  return Math.round(value * 100) / 100;
}

/** GST rate as decimal multiplier (e.g. 0.10 = 10%). */
export function exGstToIncGst(exGst: number, gstRateDecimal: number): number {
  return roundOrderMoney(exGst * (1 + gstRateDecimal));
}

export function incGstToExGst(incGst: number, gstRateDecimal: number): number {
  if (gstRateDecimal <= -1) return incGst;
  return roundOrderMoney(incGst / (1 + gstRateDecimal));
}

export function parseMoneyInput(raw: string): number | null {
  const trimmed = raw.trim().replace(/^\$/, '').replace(/,/g, '');
  if (!trimmed) return null;
  const n = Number(trimmed);
  if (!Number.isFinite(n) || n < 0) return null;
  return roundOrderMoney(n);
}

export function formatMoneyInput(value: number): string {
  return roundOrderMoney(value).toFixed(2);
}

export function formatGstRatePercentLabel(gstRateDecimal: number): string {
  return `${(gstRateDecimal * 100).toFixed(2)}%`;
}

/** Parse a GST percent input (`10` or `10.5`) into a decimal rate (`0.10`). */
export function parseGstPercentInput(raw: string): number | null {
  const trimmed = raw.trim().replace(/%/g, '');
  if (!trimmed) return null;
  const n = Number(trimmed);
  if (!Number.isFinite(n) || n < 0 || n > 100) return null;
  return Math.round((n / 100) * 10000) / 10000;
}

/** Format a decimal GST rate for an editable percent field (`0.10` → `"10"`). */
export function formatGstPercentInput(gstRateDecimal: number): string {
  const pct = Math.round(gstRateDecimal * 1000) / 10;
  return Number.isInteger(pct) ? String(pct) : pct.toFixed(1);
}

/** Order.gstRate is stored as percent after list normalize (10 = 10%). */
export function orderGstRateToDecimal(gstRatePercent: number | undefined): number | null {
  if (typeof gstRatePercent !== 'number' || !Number.isFinite(gstRatePercent) || gstRatePercent < 0) {
    return null;
  }
  return Math.round((gstRatePercent / 100) * 10000) / 10000;
}

/** 与后端 `total_price_with_gst == total_price * (1 + gst_rate)` 对齐 */
export function buildAdminCreatePrices(exGst: number, gstRateDecimal: number): {
  totalPrice: number;
  totalPriceWithGst: number;
} {
  const totalPrice = roundOrderMoney(exGst);
  const totalPriceWithGst = roundOrderMoney(totalPrice * (1 + gstRateDecimal));
  return { totalPrice, totalPriceWithGst };
}
